import { render, staticRenderFns } from "./OrdersDetail.vue?vue&type=template&id=f4a22654&scoped=true&"
import script from "./OrdersDetail.vue?vue&type=script&lang=js&"
export * from "./OrdersDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrdersDetail.vue?vue&type=style&index=0&id=f4a22654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a22654",
  null
  
)

export default component.exports